import React, { Component } from 'react';
import { AgGridReact } from "ag-grid-react";
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';
import "ag-grid-enterprise";
import DailyReportsServices from '../../services/axiosServices/apiServices/DailyReportsServices';
import SwalServices from '../../services/swalServices/SwalServices';
import { getAuthProps } from '../../utils/AuthenticationLibrary';
import moment from 'moment';
import { isValidForm } from '../../utils/validation/CommonValidator';
import { CommonValidationMessages } from '../../utils/Messages';
import { getFinancialYearDates } from '../../utils/DateUtils';
import AccountTransactionServices from '../../services/axiosServices/apiServices/AccountTransactionServices';
import MultiSelectDropdown from '../../components/dropdown/MultiSelectDropdown';
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";

// Register all Community features
ModuleRegistry.registerModules([AllCommunityModule]);

class EmployeeSalaryReport extends Component {
    constructor(props) {
        super(props);
        this.dailyReportsServices = new DailyReportsServices();
        this.SwalServices = new SwalServices();
        this.accountTransactionServices = new AccountTransactionServices();
        this.gridRef = React.createRef();
        this.state = {
            isTable2Expanded: false,
            isTable3Expanded: false,
            rowData: [],
            colDefs: [],
            employeeList: [],
            paginationPageSize: 50,
            rowHeight: 40,
            idCompany: 0,
            requestDetails: {
                fromDate: "",
                toDate: "",
                idEmployee: null,
                employeeName: null
            },
            validState: {
                isValid: true,
                error: {},
            },
            validationRules: {
                fromDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "from date"
                        ),
                    }
                ],
                toDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "to date"
                        ),
                    }
                ],
                idEmployee: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "employee"
                        ),
                    }
                ],
            }
        };
    }
    handleChange = (event, name) => {
        let value = event.target.value;
        let details = this.state.requestDetails;
        if (name === "fromDate") {
            details[name] = value
        } else {
            details[name] = value
        }
        this.setState({ requestDetails: details });
    };

    componentDidMount = () => {
        let prop = getAuthProps()
        //debugger
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany }, () => {
                this.getEmployeeSalaryDropdown()
            });
        } else {
        } setTimeout(() => {
            this.removeDefaultBorders();
        }, 100);

        let details = this.state.requestDetails
        details.fromDate = getFinancialYearDates().fromDate;
        details.toDate = getFinancialYearDates().toDate;
        this.setState({ requestDetails: details })

    }
    componentDidUpdate(prevState) {
        if (prevState.rowData !== this.state.rowData) {
            const newSumRow = this.calculateSumRow();
            if (JSON.stringify(this.state.sumRow) !== JSON.stringify(newSumRow)) {
                this.setState({ sumRow: newSumRow });
            }
        }
    }

    getEmployeeSalaryDropdown = () => {
        let request = {
            idCompany: this.state.idCompany,
            idFinancialYear: 2
        }
        this.accountTransactionServices.getEmployeeSalaryDropdown(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let dropDowndata = response.responseItem.responseContent;
                let employeeList = dropDowndata.filter(item => item.source === 'Master_Employee');
                this.setState({ employeeList: employeeList });
            }
        });
    }

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        setTimeout(() => {
            this.removeDefaultBorders();
        }, 0);

    };
    removeDefaultBorders = () => {
        const pinnedHeader = document.querySelector(".ag-pinned-left-header");

        if (pinnedHeader) {
            pinnedHeader.style.borderRight = "none";
        }

        const removeCellBorders = () => {
            const pinnedCells = document.querySelectorAll(".ag-cell-last-left-pinned");
            pinnedCells.forEach((cell) => {
                cell.style.borderRight = "none";
            });
        };

        removeCellBorders();
        const observer = new MutationObserver(() => {
            if (pinnedHeader) pinnedHeader.style.borderRight = "none";
            removeCellBorders();
        });

        observer.observe(document.body, { childList: true, subtree: true });
    };

    downloadIssueProcessEmployeeReportDateWise = () => {
        const isValidAllFields = this.isValidAllFields();
        if (isValidAllFields) {
            let request = {
                idCompany: this.state.idCompany,
                fromDate: this.state.requestDetails.fromDate,
                toDate: this.state.requestDetails.toDate,
                idEmployee: this.state.requestDetails.idEmployee ? this.state.requestDetails.idEmployee : 0
            };
            this.dailyReportsServices.downloadIssueProcessEmployeeReportDateWise(request).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    let data = response.responseItem.responseContent;
                    if (data.length > 0) {
                        const dynamicColDefs = Object.keys(data[0]).map((key) => ({
                            field: key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            minWidth: this.getColumnWidth(key),
                            flex: this.getColumnFlex(key),
                            filter: true,
                            floatingFilter: true,
                            valueFormatter: key.includes("startDate") || key.includes("completeDate") ? (params) => {
                                if (!params.value) return "";
                                return moment(params.value).format("DD-MM-YYYY");
                            } : null,
                        }));
                        this.setState({
                            rowData: data,
                            colDefs: dynamicColDefs,
                        }, () => {
                            this.setState({ sumRow: this.calculateSumRow() });
                        });
                    }
                }
            });
        }
    }

    getColumnWidth = (key) => {
        const columnWidth = {
            "jobworkNo": 100,
            "from": 110,
            "itemName": 220,
            "drawingNo": 150,
            "employeeName": 150,
            "process": 140,
            "startDate": 120,
            "completeDate": 130,
            "allocatedQty": 120,
            "processRates": 120,
            "totalAmount": 120,
        }
        return columnWidth[key] !== undefined ? columnWidth[key] : 120;
    }
    getColumnFlex = (key) => {
        const columnFlex = {
            "jobworkNo": 1,
            "from": 1,
            "itemName": 3,
            "drawingNo": 2,
            "employeeName": 2,
            "process": 2,
            "startDate": 1,
            "completeDate": 1,
            "allocatedQty": 1,
            "processRates": 1,
            "totalAmount": 1,
        }
        return columnFlex[key] !== undefined ? columnFlex[key] : 1;
    }

    calculateSumRow = () => {
        const { rowData } = this.state;
        return {
            jobworkNo: "Total",
            allocatedQty: rowData.reduce((sum, row) => sum + (row.allocatedQty || 0), 0),
            processRates: rowData.reduce((sum, row) => sum + (row.processRates || 0), 0),
            totalAmount: rowData.reduce((sum, row) => sum + (row.totalAmount || 0), 0),
        };
    };

    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.requestDetails,
            this.state.validationRules,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    setFilterParameters = (event, name) => {
        let value = event ? event.value : null;
        let details = this.state.requestDetails;
        details[name] = value
        details.employeeName = event ? event.label : null
        this.setState({ requestDetails: details });
    }

    onExportPdf = () => {
        const doc = new jsPDF({ orientation: "landscape", unit: "mm", format: "a4" });

        const { fromDate, toDate } = this.state.requestDetails;

        const pageWidth = doc.internal.pageSize.getWidth();

        // Header content
        const headerLines = [
            `From: ${moment(fromDate).format('DD-MM-YYYY')} To: ${moment(toDate).format('DD-MM-YYYY')}`,
            `Employee Name: ${this.state.requestDetails.employeeName}`
        ];

        // Header styles
        const headerFontSize = 12;
        const headerTextColor = [80, 80, 80]; // white
        const headerBgColor = [245, 245, 245]; // blue
        const lineHeight = 8;
        const padding = 2;

        // Calculate total header height
        const totalHeaderHeight = headerLines.length * lineHeight + padding * 2;

        // Draw background rectangle for header
        doc.setFillColor(...headerBgColor);
        doc.rect(0, 0, pageWidth, totalHeaderHeight, 'F');

        // Set text styles
        doc.setFontSize(headerFontSize);
        doc.setTextColor(...headerTextColor);

        // Draw each header line centered
        headerLines.forEach((line, i) => {
            const textWidth = doc.getTextWidth(line);
            const x = (pageWidth - textWidth) / 2;
            const y = padding + (i + 1) * lineHeight - 2;
            doc.text(line, x, y);
        });

        // Prepare table data — drop Sr No and employeeName (already shown in header section)
        const filteredCols = this.state.colDefs.filter(
            col => col.headerName !== "Sr No" && col.field !== "employeeName"
        );

        const rowData = [];

        this.gridRef.current.api.forEachNodeAfterFilterAndSort((node) => {
            rowData.push(
                filteredCols.map(col => {
                    let value = node.data[col.field];

                    if (col.field === "startDate" || col.field === "completeDate") {
                        return value ? moment(value).format("DD-MM-YYYY") : "";
                    }

                    return value;
                })
            );
        });

        const pinnedBottomRows = this.gridRef.current.api.getPinnedBottomRowCount();

        for (let i = 0; i < pinnedBottomRows; i++) {
            const pinnedNode = this.gridRef.current.api.getPinnedBottomRow(i);

            rowData.push(
                filteredCols.map(col => {
                    let value = pinnedNode.data[col.field];

                    if (col.field === "startDate" || col.field === "completeDate") {
                        return value ? moment(value).format("DD-MM-YYYY") : "";
                    }

                    return value;
                })
            );
        }

        const columnHeaders = filteredCols.map(col => col.headerName);

        // Per-column widths (mm) tuned so headers don't wrap on A4 landscape (~277mm usable)
        const pdfColumnWidth = {
            jobworkNo: 18,
            from: 22,
            itemName: 60,
            drawingNo: 32,
            process: 30,
            startDate: 24,
            completeDate: 26,
            allocatedQty: 22,
            processRates: 22,
            totalAmount: 22,
        };
        const columnStyles = filteredCols.reduce((acc, col, idx) => {
            const w = pdfColumnWidth[col.field];
            if (w !== undefined) acc[idx] = { cellWidth: w };
            return acc;
        }, {});

        // Render table below header
        autoTable(doc, {
            head: [columnHeaders],
            body: rowData,
            startY: totalHeaderHeight + 4, // leave space below header
            margin: { left: 8, right: 8 },
            styles: { fontSize: 8, cellPadding: 2, overflow: "linebreak" },
            headStyles: { fillColor: [63, 140, 255], textColor: 255, halign: "center" },
            columnStyles,
        });

        doc.save("employee-salary-report.pdf");
    };

    render() {
        return (
            <div className='sales-general-register'>
                <div className="data-display">
                    <div className="data-display-inner">
                        <div className='search-grp bg-white shadow-normalShadow rounded-[10px] p-[10px] w-[80%] mb-[10px]'>
                            <p className='mb-[5px] font-semibold text-blue text-[16px]'>Select date</p>
                            <div className='item-grp flex gap-[10px] items-end'>
                                <div className='input-grp w-full'>
                                    <label>From date</label>
                                    <input type='date' className={`px-[10px] py-[5px] ${this.state.validState?.error?.fromDate !== undefined ? "error" : ""}`}
                                        onChange={(event) => this.handleChange(event, "fromDate")}
                                        value={this.state.requestDetails.fromDate}
                                    />
                                </div>
                                <div className='input-grp w-full'>
                                    <label>To date</label>
                                    <input type='date' className={`px-[10px] py-[5px] ${this.state.validState?.error?.toDate !== undefined ? "error" : ""}`}
                                        onChange={(event) => this.handleChange(event, "toDate")}
                                        value={this.state.requestDetails.toDate}
                                    />
                                </div>
                                <div className='input-grp w-full'>
                                    <label>Employee</label>
                                    <MultiSelectDropdown
                                        className={this.state.validState?.error?.idEmployee !== undefined ? "error" : ""}
                                        options={this.state.employeeList}
                                        value={this.state.requestDetails.idEmployee ? this.state.employeeList?.find(item => item.value === this.state.requestDetails.idEmployee) : 0}
                                        onChange={(event) =>
                                            this.setFilterParameters(event, "idEmployee")
                                        }
                                    />
                                </div>
                                <button className='prm-btn h-fit ml-[10px]'
                                    onClick={() => { this.downloadIssueProcessEmployeeReportDateWise() }}
                                >Search
                                </button>
                            </div>
                        </div>
                        <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className="table-1 h-[72vh] w-full px-[1px] rounded-[5px]">
                                <div className="table-inner flex items-center justify-between mb-2.5">
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Employee Records</h1>
                                    <div className='btn-grp flex items-center gap-2.5'>
                                        {this.state.rowData.length > 0 ?
                                            <>
                                                {/* <button className='prm-btn h-fit text-[14px] rounded-[8px] px-[16px] py-[8px]' onClick={() => this.onExportExcel()}>Export to Excel</button> */}
                                                <button className='prm-btn h-fit text-[14px] rounded-[8px] px-[16px] py-[8px]' onClick={() => this.onExportPdf()}>Export to PDF</button>
                                            </>
                                            : null}
                                    </div>
                                </div>
                                <AgGridReact
                                    ref={this.gridRef}
                                    rowData={this.state.rowData} // Pass row data
                                    rowHeight={this.state.rowHeight}
                                    headerHeight={65}
                                    columnDefs={this.state.colDefs}
                                    rowSelection={this.rowSelection}
                                    pinnedBottomRowData={[this.state.sumRow]}
                                    rowClassRules={{
                                        "sum-row": (params) => params.node.rowPinned === "bottom"
                                    }}
                                    onGridReady={this.onGridReady}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default EmployeeSalaryReport;